import { render, staticRenderFns } from "./TradeInForm.vue?vue&type=template&id=2c4eb2be"
import script from "./TradeInForm.vue?vue&type=script&lang=js"
export * from "./TradeInForm.vue?vue&type=script&lang=js"
import style0 from "./TradeInForm.vue?vue&type=style&index=0&id=2c4eb2be&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports